module.exports = __webpack_public_path__ + "static/dmon-020-cefdaf7423f8d765d1e369461d60c832.jpg";